<template>
  <span class="dob-wrapper">
    <input type="text" class="form-control dob-input" placeholder="Select a Date" v-model="dobInInput" v-on:input="openDOB($event)" />
    <datepicker v-show="showCalendar" class="text-left mb-15" input-class="datepicker-class form-control" v-model="datepickerModel" :format="'dd MMM yyyy'" name="paricipantBirthDate" :open-date="dobInInputComputed" ref="datepicker" v-on:selected="dobSelected($event)"> </datepicker>
    <span class="calendar-icon-span" @click="calendarIconClicked()">
      <img src="/static/img/calendar.svg" alt="Calendar" class="cal-icon-dob" />
    </span>
  </span>
</template>
<script>
import momentTimeZone from "moment-timezone";
import Datepicker from "vuejs-datepicker";

export default {
  name: "participant-dob-sewction",
  components: {
    Datepicker
  },
  props: {
    condition: {
      type: Object,
      required: false,
      default: null
    },
    index: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      showCalendar: false,
      datepickerModel: null,
      dobInInput: null
    };
  },
  watch: {
    condition: {
      deep: true,
      immediate: true,
      handler: function(newVal) {
        if (newVal && newVal.value && this.validateDOBFormat(newVal.value)) {
          this.dobInInput = newVal.value;
        }
      }
    }
  },
  computed: {
    dobInInputComputed: function() {
      if (typeof this.condition.value === "string" && this.condition.value && this.validateDOBFormat(this.condition.value)) {
        this.updateDatePickerVal();
        return new Date(this.condition.value);
      }
      return new Date();
    }
  },
  methods: {
    updateDatePickerVal() {
      this.datepickerModel = new Date(this.condition.value);
    },
    validateDOBFormat(dateString) {
      if (!dateString) {
        return false;
      }

      if (this.typeOf(dateString) === "String") {
        const validDate = dateString.match(/^((0[1-9]|1[0-9]|2[0-9]|3[0-1])[\s](JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[\s](\d{4}))$/);
        return validDate;
      } else {
        return false;
      }
    },
    openDOB(event) {
      const date = event.target.value;
      this.dobSelected(date);
      if (!date) {
        this.$toastr.error("Enter a valid date in the format DD MMM YYYY.");
      } else {
        if (this.validateDOBFormat(date)) {
        } else {
          this.$toastr.error("Enter a valid date in the format DD MMM YYYY.");
        }
      }
    },
    calendarIconClicked() {
      this.showCalendar = true;

      const _this = this;

      this.$nextTick(function() {
        _this.$refs.datepicker.showCalendar();
        _this.$refs.datepicker.$el.querySelector("input").focus();
      });
    },
    dobSelected(event) {
      const dob = this.typeOf(event) === "Date" || this.validateDOBFormat(event) ? this.getFormattedDate(event) : event;
      this.$emit("dob-selected", dob);
    },
    getFormattedDate(dateStr) {
      return momentTimeZone(dateStr)
        .format("DD MMM YYYY")
        .toUpperCase();
    },
    typeOf(value) {
      if (Object.prototype.toString.call(value) === "[object Date]") {
        return "Date";
      } else if (Object.prototype.toString.call(value) === "[object Object]") {
        return "Object";
      } else if (Object.prototype.toString.call(value) === "[object String]") {
        return "String";
      } else {
        return value;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/* CSS for date-picker starts */

.datepicker-class {
  background-color: #fff !important;
}

.dob-wrapper {
  position: relative;
  width: 100% !important;
  height: 2.15rem !important;
  top: -8px !important;
  width: 100%;
  border-radius: 4px;
  padding: 16px 8px;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  border: solid 1px #d3dfe4;
}

.dob-input {
  position: absolute;
  height: 2rem !important;
  border: solid 1px #d3dfe4;
  padding: 7px 37px 6px 17px;
  border-radius: 3px;
  cursor: auto;
  margin-bottom: 0px;
  border: none;
  width: 100%;
  right: 0px;
  top: 0px;
  display: block;
}

.dob-input,
input[type="text"]::-webkit-input-placeholder:after {
  content: "*";
  color: red;
  vertical-align: top;
  font-size: 10px;
}

/deep/ .vdp-datepicker {
  position: absolute;
  top: 3px;
  left: 129px;
}

/deep/ .vdp-datepicker > div:first-child {
  input[type="text"] {
    background: transparent !important;
    border-color: transparent !important;
    content: transparent !important;
    color: transparent !important;
    border-radius: 2px !important;
    width: 2.1rem !important;
    height: 1.9rem !important;
    position: absolute !important;
    right: -22px !important;
    top: -2px !important;
  }
}

/deep/ .vdp-datepicker__calendar {
  left: -129px;
  top: 31px;
}

.calendar-icon-span {
  position: absolute;
  top: 6px;
  cursor: pointer;
  display: block;
  right: 8px;
}

/* CSS for date-picker ends */
</style>
